// Links to one element or connection on a drawing:
//   /drawing/<drawingId>/element/<elementId>
//   /drawing/<drawingId>/connection/<connectionId>
//   /drawing/<drawingId>?view=<x>,<y>,<w>,<h>    a region in page pixels (e.g.
//                                                a pipeline result that isn't saved)

const KINDS = ['element', 'connection'];

// The rest of the path after /drawing/<id>/ -> { kind, id } | null.
export function parseItemPath(rest) {
  const [kind, id, ...more] = String(rest || '').split('/').filter(Boolean);
  if (!KINDS.includes(kind) || !id || more.length) return null;
  return { kind, id };
}

export function drawingPath(drawingId, item = null) {
  return item ? `/drawing/${drawingId}/${item.kind}/${item.id}` : `/drawing/${drawingId}`;
}

// "x,y,w,h" -> { x, y, width, height } | null.
export function parseViewParam(value) {
  const n = String(value || '').split(',').map(Number);
  if (n.length !== 4 || n.some(v => !Number.isFinite(v)) || n[2] <= 0 || n[3] <= 0) return null;
  return { x: n[0], y: n[1], width: n[2], height: n[3] };
}
